document.addEventListener('DOMContentLoaded', function() {
  const scrollBanner = document.querySelector('.comp-hover-scroll-banner');
  if (!scrollBanner) return;

  const cards = scrollBanner.querySelectorAll('.gallery-with-text__card');
  
  cards.forEach(card => {
    card.addEventListener('mouseenter', function() {
      cards.forEach(item => {
        item.classList.remove('active')
        $(item).find('.link--overlay').removeClass('active')
      });
      this.classList.add('active');
      $(this).find('.link--overlay').addClass('active');
    });
  });
});